module.exports = __webpack_public_path__ + "static/media/bloomberg.91e3fc97.jpg";